var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader-wrapper",attrs:{"id":"loader"}},[_vm._m(0),_c('div',{staticClass:"text"},[_vm._l((_vm.phrases),function(phrase,idx){return [_c('p',{key:idx,class:`desc_${idx+1}`,attrs:{"id":`receiptPhrase${idx+1}`}},[_vm._v(_vm._s(_vm.$t(phrase)))])]})],2)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"scanner"},[_c('div',{staticClass:"invoice"}),_c('div',{staticClass:"scanner-bar"})])
}]

export { render, staticRenderFns }